<template>
  <div>
    <!-- {{ groups }} -->
    <v-simple-table
      dense
      :style="tableStyle"
      :class="{ deactivateLinks: deactivateLinks }"
    >
      <template v-slot:default>
        <thead>
          <tr v-if="title">
            <td
              :colspan="headers.length"
              :style="titleStyle"
              class="text-h6 py-1 px-2 text-center"
            >
              <div class="d-flex flex-row align-center">
                <slot name="image"></slot>
                <div>{{ title }}</div>
              </div>
            </td>
          </tr>
          <tr v-if="hasHeaders">
            <td
              class="font-weight-medium"
              :style="headerStyle"
              v-for="(header, i) in headers"
              :key="'header' + i"
            >
              <vue-markdown class="mdContent" :key="header + i">{{
                header
              }}</vue-markdown>
            </td>
          </tr>
        </thead>

        <tbody v-for="(group, i) in groups" :key="'group' + i">
          <tr v-if="group.name && groups.length > 1" class="">
            <th
              :colspan="headers.length"
              :style="groupStyle"
              class="text-center"
            >
              <vue-markdown class="mdContent" :key="'groupMD_' + i">{{
                group.name
              }}</vue-markdown>
            </th>
          </tr>

          <tr v-for="(row, rowIndex) in group.items" :key="'row' + rowIndex">
            <td
              v-for="(cell, cellIndex) in row"
              :key="`${rowIndex}_${cellIndex}`"
              :class="cellIndex == 0 ? ' font-weight-medium ' : ''"
              :style="cellIndex == 0 ? 'headerStyle' : ''"
            >
              <list-or-text :content="cell"></list-or-text>
            </td>
          </tr>
        </tbody>
        <tbody v-if="notes">
          <tr>
            <td :colspan="headers.length" class="py-2" :class="notesClass">
              <vue-markdown class="mdContent" :key="notes">{{
                notes
              }}</vue-markdown>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import ListOrText from "@/components/pagesStuff/ListOrText";
import VueMarkdown from "@adapttive/vue-markdown";

export default {
  name: "DataTable",
  components: { ListOrText, VueMarkdown },
  props: {
    headers: null,
    groups: null,
    title: null,
    notes: null,
    titleStyle: {
      type: String,
      default: "background-color: #bfe7ff;border-bottom: 1px solid #95b8d0;",
    },
    headerStyle: { type: String, default: "background-color: #f0f9ff;" },
    tableStyle: { type: String, default: "border: 1px solid #95b8d1;" },
    groupStyle: {
      type: String,
      default: "background-color: #d9f1ff; font-size: 17px;",
    },
    notesClass: { type: String, default: "caption" },
    hasHeaders: { type: Boolean, default: true },
    deactivateLinks: null, // makes links inactive (eg when previewing in admin and don't want to accidentally navigate away)
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    // hasHeaders: function () {
    //   let rtn = false;
    //   this.headers.forEach((h) => {
    //     if (h && h != "") rtn = true;
    //   });
    //   return rtn;
    // },
  },
};
</script>

<style scoped>
.notesClass {
  border: 1px solid gray;
  background-color: yellow;
  max-width: 500px;
}
table,
table td,
table th {
  border: 0.5px solid #bbd4e4;
}
td,
th {
  max-width: 800px;
}
.deactivateLinks >>> a {
  pointer-events: none;
}
</style>
